<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../provider.js';

const { attachments } = useMessageContext();

const attachment = computed(() => attachments.value[0]);
</script>

<template>
  <img
    v-if="attachment"
    :src="attachment.dataUrl"
    class="skip-context-menu w-32 h-32 object-contain"
    data-bubble-name="sticker"
  />
</template>
